import { TSAType } from "src/app/core/survey/inside-survey/models/tsaType.enum";
import { CopperIntroType } from "../../../core/survey/inside-survey/models/copperIntroType.enum";
import { ExistingTelcoCoax } from "../../../core/survey/inside-survey/models/existingTelcoCoax.enum";
import { ExistingTelcoConnections } from "../../../core/survey/inside-survey/models/existingTelcoConnections.enum";
import { ExistingVerticalCabling } from "../../../core/survey/inside-survey/models/existingVerticalCabling.enum";
import { InsideIntroduction } from "../../../core/survey/inside-survey/models/insideIntroduction.enum";
import { Quadrant } from "../../../core/survey/inside-survey/models/quadrant.enum";
import { InsideCopperIntroPhotoRemarksDto } from "./InsideCopperIntroPhotoRemarksDto";
import { InsideFibreIntroPhotoRemarksDto } from "./InsideFibreIntroPhotoRemarksDto";
import { OutsideCopperIntroPhotoRemarksDto } from "./OutsideCopperIntroPhotoRemarksDto";
import { OutsideFibreIntroPhotoRemarksDto } from "./OutsideFibreIntroPhotoRemarksDto";
import { ProximusEquipmentPhotoRemarksDto } from "./ProximusEquipmentPhotoRemarksDto.1";

export class UpdateInsideSurveyTechnicalInfoDTO {
  constructor(
    readonly id: string,
    readonly introduction: InsideIntroduction,
    readonly quadrant: Quadrant,
    readonly horizontalTechnicalShaft: boolean,
    readonly verticalTechnicalShaft: boolean,
    readonly electricityInTelcoRoom: boolean,
    readonly roomAvailableForFutureIntroBox: boolean,
    readonly otherTelcoRemarks: string,
    readonly individualCoaxCableFromBasement: boolean,
    readonly copperIntroType: CopperIntroType,
    readonly existingTelcoCoax: ExistingTelcoCoax,
    readonly existingTelcoCoaxQuantity: number,
    readonly existingTelcoConnections: ExistingTelcoConnections,
    readonly existingVerticalCabling: ExistingVerticalCabling,
    readonly nrOfCopperIntros: number,
    readonly nrOfDesiredFibreIntros: number,
    readonly accessToTelcoGeneralRemarks: string,
    readonly generalTechnicalInfoPhotoRemark: ProximusEquipmentPhotoRemarksDto[],
    readonly electricityInTelcoRoomPhotoRemark: string,
    readonly roomAvailableForNewEquipmentPhotoRemark: string,
    readonly outsideCopperIntroPhotoRemark: string,
    readonly insideCopperIntroPhotoRemark: string,
    readonly outsideFibreIntroPhotoRemark: string,
    readonly insideFibreIntroPhotoRemark: string,
    readonly proximusEquipmentPhotoRemarks: ProximusEquipmentPhotoRemarksDto[],
    readonly telcoRoomIntroPhotoRemarks: ProximusEquipmentPhotoRemarksDto[],
    readonly insideCopperIntroPhotoRemarks: InsideCopperIntroPhotoRemarksDto[],
    readonly outsideCopperIntroPhotoRemarks: OutsideCopperIntroPhotoRemarksDto[],
    readonly insideFibreIntroPhotoRemarks: InsideFibreIntroPhotoRemarksDto[],
    readonly outsideFibreIntroPhotoRemarks: OutsideFibreIntroPhotoRemarksDto[],
    readonly nrOfGutters: number,
    readonly nrOf90DegreeCorners: number,
    readonly nrOfInsideOutsideCorners: number,
    readonly nrOfEndKitsForGutters: number,
    readonly nrOfHorizontalDrilling: number,
    readonly nrOfVerticalDrilling: number,
    readonly nrOfSealingKitsForDrillingHoles: number,
    readonly sellingHigherThan3and5m: boolean,
    readonly specialBuilding: boolean,
    readonly specialBuildingRemark: string,
    readonly heightOver3M50: boolean,
    readonly specificHeightSpecialNeeds: boolean,
    readonly specificInstructionsAesthetics: boolean,
    readonly standardCableDuctsObligatory: boolean,
    readonly specialCableDuctOrStandardCableDuctMoreThan20M: boolean,
    readonly needForSpeedpipeTypeSheath: boolean,
    readonly needForFlextubeTypeSheath: boolean,
    readonly passageThroughExteriorHallway: boolean,
    readonly passageOutsideSpecificEquipment: boolean,
    readonly passageThroughFalseCeilings: boolean,
    readonly passageThroughFalseFloor: boolean,
    readonly floorboxNotOnSameFloorAsApartment: boolean,
    readonly serviceLineConnection: boolean,
    readonly severalTechnicalShafts: boolean,
    readonly floorboxPresentInQuadrantC: boolean,
    readonly extensionOfExistingTechnicalShaft: boolean,
    readonly cableMoreThan50MOr2ManFiber: boolean,
    readonly specialDrilling: boolean,
    readonly mivbStibStation: boolean,
    readonly accessToBuilding: boolean,
    readonly shadowportfolioSolution: boolean,
    readonly technicalSolutionAesthetics: boolean,
    readonly technicalSolutionImpact: boolean,
    readonly technicalSolutionTooComplex: boolean,
    readonly noAdminTSA: boolean,
    readonly tsaType: TSAType
  ) {}

  static create(info: Partial<UpdateInsideSurveyTechnicalInfoDTO>) {
    return new UpdateInsideSurveyTechnicalInfoDTO(
      info.id,
      info.introduction,
      info.quadrant,
      info.horizontalTechnicalShaft,
      info.verticalTechnicalShaft,
      info.electricityInTelcoRoom,
      info.roomAvailableForFutureIntroBox,
      info.otherTelcoRemarks,
      info.individualCoaxCableFromBasement,
      info.copperIntroType,
      info.existingTelcoCoax,
      info.existingTelcoCoaxQuantity,
      info.existingTelcoConnections,
      info.existingVerticalCabling,
      info.nrOfCopperIntros,
      info.nrOfDesiredFibreIntros,
      info.accessToTelcoGeneralRemarks,
      info.generalTechnicalInfoPhotoRemark,
      info.electricityInTelcoRoomPhotoRemark,
      info.roomAvailableForNewEquipmentPhotoRemark,
      info.outsideCopperIntroPhotoRemark,
      info.insideCopperIntroPhotoRemark,
      info.outsideFibreIntroPhotoRemark,
      info.insideFibreIntroPhotoRemark,
      info.proximusEquipmentPhotoRemarks,
      info.telcoRoomIntroPhotoRemarks,
      info.insideCopperIntroPhotoRemarks,
      info.outsideCopperIntroPhotoRemarks,
      info.insideFibreIntroPhotoRemarks,
      info.outsideFibreIntroPhotoRemarks,
      info.nrOfGutters,
      info.nrOf90DegreeCorners,
      info.nrOfInsideOutsideCorners,
      info.nrOfEndKitsForGutters,
      info.nrOfHorizontalDrilling,
      info.nrOfVerticalDrilling,
      info.nrOfSealingKitsForDrillingHoles,
      info.sellingHigherThan3and5m,
      info.specialBuilding,
      info.specialBuildingRemark,
      info.heightOver3M50,
      info.specificHeightSpecialNeeds,
      info.specificInstructionsAesthetics,
      info.standardCableDuctsObligatory,
      info.specialCableDuctOrStandardCableDuctMoreThan20M,
      info.needForSpeedpipeTypeSheath,
      info.needForFlextubeTypeSheath,
      info.passageThroughExteriorHallway,
      info.passageOutsideSpecificEquipment,
      info.passageThroughFalseCeilings,
      info.passageThroughFalseFloor,
      info.floorboxNotOnSameFloorAsApartment,
      info.serviceLineConnection,
      info.severalTechnicalShafts,
      info.floorboxPresentInQuadrantC,
      info.extensionOfExistingTechnicalShaft,
      info.cableMoreThan50MOr2ManFiber,
      info.specialDrilling,
      info.mivbStibStation,
      info.accessToBuilding,
      info.shadowportfolioSolution,
      info.technicalSolutionAesthetics,
      info.technicalSolutionImpact,
      info.technicalSolutionTooComplex,
      info.noAdminTSA,
      info.tsaType
    );
  }
}
